export default __webpack_public_path__ + "images/TQ.441ed9e.png";